import { setChatChannelName, removeChatChannelName, removeChatIdentity } from 'src/utils/helpers'

const initialState = {
  isChatEmpty: true,
  staffMembers: [],
  headerMessage: null,
  chatEmail: null,
  unreadCount: 0,
  chatReset: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'SET_CHAT_DATA': {
      if (!(action.payload && action.payload.hasOwnProperty('data') && action.payload.data)) {
        return state
      }

      const { data, user, isChatEmpty } = action.payload
      const { channelName, staffMembers, headerMessage } = data

      setChatChannelName(channelName, user, isChatEmpty)
      return {
        ...state,
        // if old staff members lenght is greate than new one it means chat got assignee update
        // during the current session so keeping the old version of staffmembers
        staffMembers:
          state.staffMembers.length > staffMembers.length ? state.staffMembers : staffMembers,
        headerMessage: headerMessage,
      }
    }

    case 'SET_IS_CHAT_EMPTY': {
      return {
        ...state,
        isChatEmpty: action.payload.isChatEmpty,
      }
    }

    case 'RESET_CHAT_SESSION': {
      removeChatChannelName()
      removeChatIdentity()

      // Reset only private/session data, because we should keep staffMembers and headerMessage for example
      return {
        ...state,
        isChatEmpty: initialState.isChatEmpty,
        chatEmail: initialState.chatEmail,
        unreadCount: initialState.unreadCount,
        chatReset: true,
        chatInit: false,
      }
    }
    case 'SET_CHAT_INIT': {
      const chatReset = action.payload ? false : state.chatReset
      return {
        ...state,
        chatInit: action.payload,
        chatReset,
      }
    }

    // case 'UPDATE_TOKEN': {
    //   return {
    //     ...state,
    //     token: action.payload.token
    //   }
    // }

    case 'SET_CHAT_EMAIL': {
      return {
        ...state,
        chatEmail: action.payload.chatEmail,
      }
    }

    case 'UPDATE_UNREAD_COUNT': {
      return {
        ...state,
        unreadCount: action.payload.unreadCount,
      }
    }

    case 'UPDATE_STAFF_MEMBER_COMMIT': {
      if (!action.payload) {
        return state
      }
      return {
        ...state,
        staffMembers: [...state.staffMembers, action.payload],
      }
    }

    default: {
      return state
    }
  }
}
